import React, { useState, FC, useEffect } from "react";
import TabButton from "../../components/layout/Sections/TabButton";
import TabContent from "../../components/layout/Sections/TabContent";
import Contaier from "../../components/layout/Container/Container";
import Banner from "../../components/layout/Sections/Banner";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";

import { useLocation } from "react-router-dom";
import VetHealthInspectionApplication from "./VetHealthInspectionApplication";
import VetHealthInspectionDashboard from "../DashBoard/Inspection/VetHealthInspectionDashboard";

const VetHealthInspection = () => {
  const name = "E-services";
  const name2 = "Application Details";
  const buttonName = "Registration Mode";
  const buttonName3 = "Dashboard";

  const location = useLocation();
  const bannerType = location.state;
  const inspectionId = location.state?.id;

  let bannerName = "Vet Health - Border Control Inspections";

  const [activeButton, setActiveButton] = useState<string>("v-pills-home-tab");
  const [activeTab, setActiveTab] = useState<string>("v-pills-home");

  const handleButtonClick = (buttonId: string, tabId: string) => {
    setActiveButton(buttonId);
    setActiveTab(tabId);
  };

  useEffect(() => {
    if (inspectionId !== undefined) {
      setActiveButton("v-pills-home-tab");
      setActiveTab("v-pills-home");
    }
  }, [inspectionId]);

  interface TabPages {
    [key: string]: FC<any>; // Use the appropriate prop type for your components
  }

  const tabPages: TabPages = {
    "v-pills-services": VetHealthInspectionDashboard,
    "v-pills-home": VetHealthInspectionApplication,
    // ... add other tab pages here
  };

  return (
    <>
      <Header />
      <Contaier>
        <Banner name={bannerName} uiClass="banner-bg-content" />
        <div className="inner-content">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-2-5">
                <div className="filter-cnt">
                  <h3>{name}</h3>
                  <span>{name2}</span>
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <TabButton
                      buttonId="v-pills-home-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick("v-pills-home-tab", "v-pills-home")
                      }
                    >
                      {buttonName}
                    </TabButton>
                    <TabButton
                      buttonId="v-pills-services-tab"
                      activeButton={activeButton}
                      onClick={() =>
                        handleButtonClick(
                          "v-pills-services-tab",
                          "v-pills-services"
                        )
                      }
                    >
                      {buttonName3}
                    </TabButton>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-9-5">
                <div className="tab-content" id="v-pills-tabContent">
                  {Object.keys(tabPages).map((tabId) => (
                    <TabContent key={tabId} tabId={tabId} activeTab={activeTab}>
                      {tabPages[tabId]({ RegistrationType: bannerType })}
                    </TabContent>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
};

export default VetHealthInspection;
